import ApiService from "../api";

export default class ProcessoSincronizacaoService extends ApiService {

    constructor() {
        super("/api/processo-sincronizacao");
    }

    listarUltimasSincronizacao() {
        return this.get("/ultimas");
    }

    buscarRelatorioBP() {
        return this.get("/relatorio-bp");
    }
}
